<template>
    <div v-if="!totalError" class="w-full">
       
        <!--AMOUNT SEND-->
        <div class="w-full flex flex-column gap-2 mb-3">
            <span class="text-600 text-sm">Со счета:</span>
            <div v-if="wallets && wallets?.length" class="p-inputgroup w-full flex flex-column gap-2">
                <Select v-model="getWallet" :options="getWalletList" :disabled="false"
                    option-label="name" class='w-full border-2 border-round-xl' size="large" placeholder="Выберите счет">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm">
                            {{ slotProps.value.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, 'usdt') }}</span>
                        </div>
                        <span v-else class="flex align-items-center h-full py-2">
                            <div class="text-sm">{{ slotProps.placeholder }} </div>
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center w-7rem py-1 text-sm">
                            {{ slotProps.option.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, 'usdt') }}</span>
                        </div>
                    </template>
                </Select>

                <Select v-if="getWallet && getWallet.account_details && getWallet.account_details.length > 0" 
                    v-model="fromAccount" :options="getWallet.account_details" :disabled="false"
                    option-label="name" class='w-full border-2 border-round-xl' size="large" placeholder="Выберите валюту">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm uppercase">
                            <AvatarGroup v-if="slotProps.value && slotProps.value.currency" :max="2" class="gap-1">
                                <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                <Avatar v-if="slotProps.value.network" :image="getNetworkImage(slotProps.value.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            </AvatarGroup>
                            <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, slotProps.value.currency) }}</span>
                        </div>
                        <span v-else class="flex align-items-center h-full py-2">
                            <div class="text-sm">{{ slotProps.placeholder }} </div>
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center w-7rem py-1 text-sm uppercase">
                            <AvatarGroup v-if="slotProps.option && slotProps.option.currency" :max="2" class="gap-1">
                                <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                <Avatar v-if="slotProps.option.network" :image="getNetworkImage(slotProps.option.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            </AvatarGroup>
                            <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, slotProps.option.currency) }}</span>
                        </div>
                    </template>
                </Select>

            </div>
            <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>
        </div>

        <!--AMOUNT SEND-->
        <span class="text-600">{{ lang('amount_send') }}: </span>
        <div v-if="currencyGetList && loaded" class="w-full mt-2 mb-3">
            <InputAmount :amount="amountGet" :currency="currencyGet" :currencies="currencyGetList" :min="minGetLimit" :max="maxGetLimit" 
                @update:amount="val => amountGet = val" @update:currency="val => currencyGet = val"
                :disableInput="false" :disableSelect="false" digits="2" :isClearButtons="false" :isRequest="false" currencyTitleKey="currency_receive"/>
        </div>
        <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--AMOUNT RECEIVE-->
        <span class="text-600">{{ lang('amount_receive') }}:</span>
        <div class="w-full mt-2 mb-3" v-if="currencyReceiveList && loaded">
            <InputAmount :amount="amountReceive" :currency="currencyReceive" :currencies="currencyReceiveList" :min="minReceiveLimit" :max="maxReceiveLimit" 
                @update:amount="val => amountReceive = val"  @update:currency="val => currencyReceive = val"
                :disableInput="false" :disableSelect="false" digits="2" :isClearButtons="false" :isRequest="false"/>
        </div>
        <Skeleton v-if="!loaded || !currencyReceive" height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--RECIPIENTS-->
        <div v-if="loaded && recipientsAllowed && recipientChoosen && !hideRecipients">
            <span class="text-600">{{ lang('recipient_list') }}:</span>
            <RecipientsDropdown :recipients="recipientsAllowed" :recipient="recipientChoosen" @update:recipient="val => recipientChoosen = val" />
        </div>
        <Skeleton v-if="!loaded || !recipients" height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <div v-if="loaded && recipientChoosen" class="w-full mb-3">
            <span class="cursor-pointer text-primary" @click="addRecipient(true)">
                <span class="mr-2">{{ lang('create_recipient') }}</span>
                <i class="pi pi-user-plus text-600 mr-2 text-primary"></i>
            </span>
        </div>

        <div v-if="loaded && recipientsAllowed && recipientsAllowed.length && !recipientChoosen" class="w-full mb-3">
            <span class="cursor-pointer text-primary" @click="addRecipient(false)">
                <span class="mr-2">{{ lang('select_recipient') }}</span>
                <i class="pi pi-users text-600 mr-2 text-primary"></i>
            </span>
        </div>

        <div v-if="!recipientChoosen">
            <!--SEND PAY SYS-->
            <span class="text-600">{{ lang('bank_list') }}:</span>
            <PaymentSysDropdown v-if="loaded && receivePaySysList && receivePaySys" 
                :pay_sys="receivePaySys" 
                :currency="currencyGet" 
                type="send" 
                :list="receivePaySysGrouped"
                :headerText="lang('choose_senders_bank')"
                @update:pay-sys="val => chooseReceivePaySys(val)" />
            <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>

            <!--RECIPIENT FIELDS-->
            <RecipientFields v-if="receivePaySys && receivePaySys.bank" 
                @check_valid="setValidReceipent" 
                @return_fields="setFields"
                :fields="receivePaySys?.bank?.['recipient_fields'] && receivePaySys?.bank?.['recipient_fields'].length ? receivePaySys?.bank?.['recipient_fields'] : receivePaySys?.pay_sys?.['recipient_fields']" 
                :requiredFields="receivePaySys?.bank?.['recipient_fields_required'] && receivePaySys?.bank?.['recipient_fields_required'].length ? receivePaySys?.bank?.['recipient_fields_required'] : receivePaySys?.pay_sys?.['recipient_fields_required']" 
                :currency="currencyReceive"/>

        </div>
    </div>

    <!--ERRORS-->
    <div v-if="totalError" class="w-full max-w-30rem">
        <InlineMessage severity="warn" class="border-round-xl">
            {{ (totalErrorMessage == 'Error getting all merchs') ? lang('critical_error') : totalErrorMessage }}
        </InlineMessage>
    </div>
    
</template>

<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import BigNumber from 'bignumber.js'
import Helper from '@/assets/js/Helper.js'
import { reactive, ref } from 'vue'
import TransferCalculation from '@/assets/js/classes/TransferCalculation.js'
import { PaymentSystemList, BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList} from '@/assets/js/classes/Currency.js'
import InputAmount from '@/components/widgets/transfer/InputAmount.vue'
import PaymentSysDropdown from '@/components/widgets/transfer/PaymentSysDropdown.vue'
import RecipientsDropdown from '@/components/widgets/transfer/RecipientsDropdown.vue'
import RecipientFields from '@/components/widgets/RecipientFields.vue'
import { RecipientList } from '@/assets/js/classes/Recipient.js'
import { RateList } from '@/assets/js/classes/Rate.js'
import { mapActions } from  'vuex'

export default {
	name: 'WithdrawTransfer',
    props: {
        wallet_id: {
            type: Number,
            default: null
        },
        onClick: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loaded: false,
            isLoading: false,
            recalculating: false,
            totalError: false,
            totalErrorMessage: '',

            // списки
            rates: [],
            arrPaymetSystems: [],
            arrCurrencies: [],
            currencies: [],
            arrBanks: [],

            // валюты
            currencyGet: null,
            currencyGetList: [],
            currencyReceive: null,
            currencyReceiveList: [],

            // суммы
            amountGet: null,
            minGetLimit: 0,
            maxGetLimit: null,
            amountReceive: null,
            minReceiveLimit: 0,
            maxReceiveLimit: null,

            // платежные системы
			getPaySys: null, 
            getPaySysList: [],
            getPaySysListGrouped: [],

            receivePaySys: null,
            receivePaySysList: [],
            receivePaySysGrouped: [],

            recipients: [],
            recipientsAllowed: [],
            recipientChoosen: null,
            recipientFieldsValid: false,
            recipientFields: {},
            hideRecipients: false,

            wallets: [],
            getWalletList: [],
            getWallet: null,
            fromAccount: null,
            fromCurrencyCode: null,

            CALC: null,
        }
    },
    components: {
        InputAmount,
        PaymentSysDropdown,
        RecipientsDropdown,
        RecipientFields
    },
    setup () {
        const react = reactive({
            recalculating_: false,
        })
        return { react }
    },
    computed: {
        check_custom_valid(){
            if(this.recipientChoosen) {
                this.$emit('disabled', false)
                return true
            }
            if(!this.recipientFieldsValid) {
                this.$emit('disabled', true)
                return false
            }
            if(!this.getWallet || !this.fromCurrencyCode) {
                this.$emit('disabled', true)
                return false
            }
            this.$emit('disabled', false)
            return true
        },
        depositWalletId() { return this.getDepositWalletId(this.$store.getters.StateWallets)},
        depositBalance() {
            const wallets = this.$store.getters.StateWallets
            if(!wallets || !Array.isArray(wallets)) return null
            for (let i = 0; i < wallets.length; i++) {
                if(wallets[i].type == 'deposit') return wallets[i].balance
            }
            return null
        }
    },
    watch: {
        amountGet: function () {
            if(this.loaded && !this.isRecalculating){
                this.isRecalculating = true
                this.react.recalculating_ = true
			    this.Recalculate('get_amount', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
		},
        amountReceive: function () { 
            if(this.loaded && !this.isRecalculating && !this.react.recalculating_){
                this.isRecalculating = true
                this.react.recalculating_ = true
			    this.Recalculate('amount_receive', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
		},
        amountReceiveSelected: function () {
            if(this.loaded && !this.isRecalculating && this.amountReceiveSelected){
                this.isRecalculating = true
                this.react.recalculating_ = true
			    this.Recalculate('amount_receive_selected', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
		},
		currencyGet: function (that) {
            if(this.loaded && !this.isRecalculating){
                this.isRecalculating = true
                this.react.recalculating_ = true
			    this.Recalculate('currency_get', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
		},
        currencyReceive: function (that) {
            if(this.loaded && !this.isRecalculating){
                this.isRecalculating = true
                this.react.recalculating_ = true
			    this.Recalculate('currency_receive', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
		},
        recipientChoosen: function (that) {
            if(!that) return
            if(this.loaded && !this.isRecalculating){
                this.receivePaySys = this.receivePaySysList.find(item => item.bank.code == that.bank_code)
                if(!this.receivePaySys) return
                this.isRecalculating = true
                this.react.recalculating_ = true
                this.Recalculate('receive_pay_sys', this.filterPaySys).then(() => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
        },
        onClick: function () {
            this.Create()
        },
        isLoading: function(that){
            this.$emit('loading', that)
        },
        wallets: function () {
            if(!this.wallets || !this.wallets.length || this.wallets.length <= 0) return
                
            let elList = []
            for (let i = 0; i < this.wallets.length; i++) {
                const balance = this.roundAmount(this.wallets[i].balance)
                let el = {
                    id:     this.wallets[i].id,
                    type:   this.wallets[i].ext_type,
                    balance: balance,
                    name:   this.getWalletNameByType(this.wallets[i].ext_type),
                    account_details: this.wallets[i]?.account_details || []
                }
                elList.push(el)
            }
            this.getWalletList = this.getAmountedList(elList)
            this.getWallet = (this.getWalletList && this.getWalletList.length > 0) ? this.getWalletList[0] : null
            if(this.getWallet) {
                this.fromAccount = (this.getWallet.account_details && this.getWallet.account_details.length > 0) ? this.getWallet.account_details[0] : null
            }
            this.sendWalletList = elList
        },
        getWallet: function (that) {
            if(!that) return
            this.fromAccount = (that.account_details && that.account_details.length > 0) ? that.account_details[0] : null
        },
        fromAccount: function (that) {
            if(!that) return
            this.fromCurrencyCode = that.currency
        }
	},
    methods: {
        lang(value) { return this.$t(`views.transfer.${value}`)},
        ...mapActions(['ActionGetAllWallets',]),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        getFormatAmount(value, currency, decimals = 2){
            return this.helper.format_amount(value, currency, decimals)
        },
        getAmountedList(elList) {
            if(!elList || !elList.length || elList.length <= 0) return []
            const min = new BigNumber(1)
            let returnList = []
            for(let i = 0; i < elList.length; i++) {
                const bBalance = new BigNumber(elList[i].balance)
                if(bBalance.isNaN() || bBalance.isGreaterThanOrEqualTo(min)) returnList.push(elList[i])
            }
            return returnList
        },
        roundAmount(val){
            const bAmount = new BigNumber(val)
            if(bAmount.isNaN()) return 0
            const floored = bAmount.decimalPlaces(2, BigNumber.ROUND_FLOOR)
            const decimals = floored.decimalPlaces()
            if(decimals >= 2) return floored.toFixed(2)
            else if(decimals == 1)return floored.toFixed(1)
            else return floored.toFixed(0)
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        getNetworkImage(network) {
            if(!network) return null
           return this.helper.GetNetworkImage(network)
        },
        chooseGetPaySys(item){
            if(this.loaded && !this.isRecalculating){
                this.getPaySys = item, this.isRecalculating = true, this.react.recalculating_ = true
                this.Recalculate('get_pay_sys', this.filterPaySys).then(res => {
                    this.isRecalculating = false
                    this.react.recalculating_ = false
                })
            }
        },
        chooseReceivePaySys(item){
            if(this.loaded && !this.isRecalculating){
                this.receivePaySys = item, this.isRecalculating = true, this.react.recalculating_ = true
                this.Recalculate('receive_pay_sys', this.filterPaySys).then(res => {
                    this.isRecalculating = false,
                    this.react.recalculating_ = false
                })
            }
        },
        getDepositWalletId(list) {
            if(!list || !Array.isArray(list)) return null
            if(list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    if(list[i].type == 'deposit') return list[i].id
                }
            } else return null
        },
        setValidReceipent(value){
            this.recipientFieldsValid = (value) ? true : false
        },
        setFields(fields){
            this.recipientFields = fields
        },
        addRecipient(val){
            if(val){
                this.recipientChoosen = null
                this.hideRecipients = true
            } else {
                this.recipientChoosen = (this.recipientsAllowed && this.recipientsAllowed.length) ? this.recipientsAllowed[0] : null
                this.hideRecipients = false
            }
        },
        getRateFromArray(rates_array, from_currency_code, to_currency_code){
            if(!rates_array || !rates_array.length) return null
            for(let i = 0; i < rates_array.length; i++){
                if(rates_array[i].from_currency_code == from_currency_code && rates_array[i].to_currency_code == to_currency_code) 
                    return rates_array[i]
            }
            return null
        },
        getInternalPaySys(array){
            if(!array || array.length <= 0) return null
            for(let i = 0; i < array.length; i++){
                if(array[i].pay_sys && array[i].pay_sys.type && array[i].pay_sys.type == 'internal') return array[i]
            }
            return null
        },
        get_code(obj){
            if(!obj || obj.code == undefined) return ''
            return obj.code
        },
        getBankCodeFromPaySys(obj){
            if(!obj || !obj.bank || !obj.bank.code) return null
            return obj.bank.code
        },
        splitNum(num){
            return this.helper.split_num(num)
        },
        getSendCurrencies(filteredRates){
            if(!filteredRates) return []
            if(!Array.isArray(filteredRates) || !filteredRates.length) return []
            if(!this.arrCurrencies || Object.keys(this.arrCurrencies).length === 0) return []
            let currencies_obj = {}
            for (const [k, v] of Object.entries(this.arrCurrencies)) {
                for(let i = 0; i < filteredRates.length; i++) {
                    if(filteredRates[i].to_currency_code == v.code) currencies_obj[v.code] = v
                }
            }
            const values = Object.values(currencies_obj)
            values.sort((a, b) => {
                const valA = a.sort !== undefined ? a.sort : 9999
                const valB = b.sort !== undefined ? b.sort : 9999
                return valA - valB
            })
            return values
        },
        // перерасчет
		async Recalculate(from = null) {

            // console.log('from: ', from);

            // Определяем валюту отправки (по коду USDT)
            if(from=='start'){
                this.currencyGet = this.arrCurrencies['usdt']
                this.currencyGetList = [this.currencyGet]

                // Определяем валюты доступные для приема
                const filteredRates = this.rates.filter(r => r.from_currency_code == 'usdt')
                this.currencyReceiveList = this.getSendCurrencies(filteredRates)
                this.currencyReceive = this.currencyReceiveList[0]
            }
            if(!this.currencyGet || !this.currencyReceive) {
                this.totalError = true
                this.totalErrorMessage = 'No currency found' // TODO: добавить сообщение об ошибке
                return
            }

            // Определяем объект расчета
            const CALC = new TransferCalculation({})
            CALC.from_currency_code = this.currencyGet.code
            CALC.to_currency_code = this.currencyReceive.code

            // Ищем текущий курс
            const rate = this.getRateFromArray(this.rates, this.currencyGet.code, this.currencyReceive.code)
            if(!rate) {
                this.totalError = true
                this.totalErrorMessage = 'No rate found' // TODO: добавить сообщение об ошибке
                return
            }

            // Задаем курс
            CALC.setRate(rate, 'withdraw')

            // Определяем платежные системы отправителя (банки)
            if(from=='start' || from=='currency_get' || from=='currency_receive' || from=='filterPaySys'){
                const getListRaw = await PaymentSystemList.RecognizePays(rate, 'get', this.$store)
                this.getPaySysList = TransferCalculation.normalizeInternalPaySystems(getListRaw, {
                    depositWalletId: this.depositWalletId,
                    depositBalance: this.depositBalance
                })
                this.getPaySys = this.getInternalPaySys(this.getPaySysList)
                this.getPaySysListGrouped = PaymentSystemList.GroupByType(this.getPaySysList)
            }
            if(!this.getPaySys) {
                this.totalError = true
                this.totalErrorMessage = this.lang('err_enough_deposit') // TODO: сделать проверку на мин сумму вывода
                return
            }

            // Определяем платежные системы получателя (банки)
            if(from=='start' || from=='currency_get' || from=='currency_receive' || from=='filterPaySys'){
                this.receivePaySysList = await PaymentSystemList.RecognizePays(rate, 'send', this.$store)
                this.receivePaySysGrouped = PaymentSystemList.GroupByType(this.receivePaySysList)
            }

            // Определяем получателей
            // Определяем допустимые коды банков отправителя
            const allowed_send_bank_codes = this.receivePaySysList.map(item => item.bank.code)
            const allowedSendPayCodes = this.receivePaySysList.map(item => item.pay_sys.code)

            // Фильтруем получателей по валюте и банку
            this.recipientsAllowed = RecipientList.FilterRecipients(
                this.recipients,
                this.currencyReceive.code,
                allowed_send_bank_codes,
                allowedSendPayCodes
            )
            // console.log('RECIPIENTS ALLOWED: ', this.recipientsAllowed)

            if(from=='start' || from=='currency_get' || from=='currency_receive' || from=='filterPaySys'){
                // На основе получаетелей и имеющихся платежных систем и банков - определить первую подходящую платежную систему
                const recipientPaySysCodes = this.recipientsAllowed.map(item => item.payment_system_code)
                if(recipientPaySysCodes && recipientPaySysCodes.length){
                    this.receivePaySys = this.receivePaySysList.find(item => recipientPaySysCodes.includes(item.pay_sys.code))
                } else this.receivePaySys = (this.receivePaySysList[0]) ? this.receivePaySysList[0] : null
            }

            // Проверка наличия платежной системы получателя
            if(!this.receivePaySys) {
                this.totalError = true
                this.totalErrorMessage = 'No send pay sys' // TODO: добавить сообщение об ошибке
                return
            }

            // Задаем платежные системы            
            CALC.setGetPaySys(this.getPaySys.pay_sys)
            CALC.setSendPaySys(this.receivePaySys.pay_sys)

            // Банки
            CALC.setGetBank(this.getPaySys.bank)
            CALC.setSendBank(this.receivePaySys.bank)

            // Корректировка мерчантов в зависимости от типа платежной системы
            if(this.getPaySys.pay_sys.type!='merchant') CALC.merchants.get.percent = 0
            // if(this.receivePaySys.pay_sys.type!='merchant') CALC.merchants.send.percent = 0

            // Вычисляем лимиты на отправку
            this.minGetLimit = CALC.getMinGetLimit()
            this.maxGetLimit = CALC.getMaxGetLimit()

            this.firstTransferSendLimit = CALC.getFreeTransferSendLimit()
            if(this.firstTransferSendLimit && this.firstTransferSendLimit.isGreaterThan(0)) this.canFirstTransfer = true
            else this.canFirstTransfer = false
            this.firstTransferReceiveLimit = CALC.calcRecipientAmountBySenderAmount(this.firstTransferSendLimit, true)

            // сбрасываем выбранную сумму к получению при смене других параметров
            if(from!='amount_receive_selected'){
                this.amountReceiveSelected = null
            }

            const bMinGetLimit = new BigNumber(this.minGetLimit)
            const bMaxGetLimit = new BigNumber(this.maxGetLimit)

            if(!this.amountGet) this.amountGet = this.minGetLimit

            // Проверка суммы ПРИЕМА по лимитам
            const bAmountGet = new BigNumber(this.amountGet)
            if(bAmountGet.isLessThan(bMinGetLimit)) this.amountGet = this.minGetLimit
            if(bAmountGet.isGreaterThan(bMaxGetLimit)) this.amountGet = this.maxGetLimit

            // Задаем сумму ПРИЕМА
            CALC.sender.amount = new BigNumber(this.amountGet)
            CALC.recipient.amount_usdt = CALC.calcRecipientAmountUsdt()
            CALC.recipient.amount = CALC.calcRecipientAmount() 
            if(from!='amount_receive' && from!='amount_receive_selected') this.amountReceive = CALC.recipient.amount.toFixed(16)

            // коректируем amount по лимитам при переключении валюты отправки
            if(this.amountGet == null){
                this.amountGet = this.minGetLimit
                CALC.sender.amount = new BigNumber(this.amountGet)
            }

            // Вычисляем лимиты на получение 
            this.minReceiveLimit = CALC.calcRecipientAmountBySenderAmount(new BigNumber(this.minGetLimit)).toFixed(2)
            this.maxReceiveLimit = CALC.calcRecipientAmountBySenderAmount(new BigNumber(this.maxGetLimit)).toFixed(2)

            const maxSendCalcLimit = CALC.getMaxSendLimit(this.receivePaySys)
            // console.log('TOTAL MAX SEND: ', maxSendCalcLimit)
            // console.log('MIN SEND: ', this.minReceiveLimit)
            // console.log('MAX SEND: ', this.maxReceiveLimit)

            // Расчитываем сумму получения или отправки
            if(from=='amount_receive' || from=='amount_receive_selected' ){
                // Корректируем сумму получения по лимитам
                const maxReceiveLimit = new BigNumber(this.maxReceiveLimit)
                const bAmountReceive = new BigNumber(this.amountReceive)
                if(bAmountReceive.isGreaterThan(maxReceiveLimit)) this.amountReceive = this.maxReceiveLimit

                CALC.recipient.amount = new BigNumber(this.amountReceive)

                this.amountGet = CALC.calcSenderAmount().toFixed(16)
                CALC.sender.amount = new BigNumber(this.amountGet)
            }

            this.amountReceive = CALC.recipient.amount.toFixed(16)
            // console.log("FINAL SEND:", CALC.sender.amount.toFixed(16))
            // console.log("FINAL RECEIVE:", CALC.recipient.amount.toFixed(16))

            // выводим комиссии на дисплей
            this.comissionToDisplay = this.splitNum(CALC.calcAllComissions().toString()).toString() + ' USDT'

            // Выбираем получателя
            if(from=='start' || from=='currency_get' || from=='currency_receive' || from=='receive_pay_sys' || from=='filterPaySys'){
            // if(!this.recipientChoosen){
                // Сохраняем выбранный код банка отправителя
                const choosenPaySysCode = (this.receivePaySys.pay_sys && this.receivePaySys.pay_sys.code) ? this.receivePaySys.pay_sys.code : null
                const choosenSendBankCode = (this.receivePaySys.bank && this.receivePaySys.bank.code) ? this.receivePaySys.bank.code : null
                const currentRecipientBankCode = (this.recipientChoosen && this.recipientChoosen.bank_code) ? this.recipientChoosen.bank_code : null
                const currentRecipientPaySysCode = (this.recipientChoosen && this.recipientChoosen.payment_system_code) ? this.recipientChoosen.payment_system_code : null
                // console.log('BANK:', currentRecipientBankCode, '-', choosenSendBankCode)
                // console.log('PAY SYS:', currentRecipientPaySysCode, '-', choosenPaySysCode)

                // Если есть из кого выбирать
                if(this.recipientsAllowed.length > 0){
                    // console.log('CASE 1')
                    if(currentRecipientBankCode == choosenSendBankCode){
                        // console.log('CASE 1-1')
                    } else {

                        // console.log('CASE 1-2')
                        const found = this.recipientsAllowed.find(item => item.bank_code === choosenSendBankCode && item.payment_system_code === choosenPaySysCode)
                        // Если выбранный получатель найден. Если нет, то выбираем первого
                        if(found) {
                            // console.log('CASE 1-2-1')
                            this.recipientChoosen = found
                            this.hideRecipients = false
                        }
                        else {
                            // console.log('CASE 1-2-2')
                            if(from=='receive_pay_sys'){
                                // console.log('CASE 1-2-2-1')
                                this.recipientChoosen = null
                                this.hideRecipients = true
                            } else {
                                // console.log('CASE 1-2-2-2')
                                this.recipientChoosen = this.recipientsAllowed[0]
                                this.hideRecipients = false
                            }
                        }
                    }
                } else {
                    // console.log('CASE 2')
                    this.recipientsAllowed = []
                    this.hideRecipients = true
                    this.recipientChoosen = null
                }
            }
            
            CALC.calcResultRate()
            this.resultRate = CALC.rate.value.toFixed(16)
            this.CALC = CALC
            // console.log('RECALCULATE DONE', CALC.toObject())
            // console.log('GET PAYs' , this.getPaySys)
            // console.log('SEND PAYs' , this.receivePaySys)

            return
        },
        async Create(){
            this.isLoading = true 
            this.submitted = true
            let transfer = {}

            // console.log("CALC", this.CALC.toObject())

            if (!this.check_custom_valid) {
                this.isLoading = false
                this.showMess('error', this.lang('error_title'), '')
                return
            }

            // если выбран получатель, то берем его id
            const recipient_id = (this.recipientChoosen && this.recipientChoosen.id) ? this.recipientChoosen.id : null
            const recipientBankCode = (this.recipientChoosen && this.recipientChoosen.bank_code) ? this.recipientChoosen.bank_code : null

            try {

                let fbp, fbc, url
                try{
                    fbp = this.helper.getFbp()
                    fbc = this.helper.getFbc()
                    url = this.helper.getUrl()
                } catch(e) {
                    console.log('error', e)
                }

                const data = {
                    wallet_id: this.wallet_id,
                    from_currency_code: this.fromCurrencyCode,
                    to_currency_code: this.get_code(this.currencyReceive),
                    amount_send: this.CALC.sender.amount.toFixed(16),
                    amount_receive: this.CALC.recipient.amount.toFixed(16),
                    payment_system_code: this.receivePaySys.pay_sys.code,
                    payment_system_type: this.receivePaySys.pay_sys.type,
                    bank_code: (recipientBankCode) ? recipientBankCode : (this.receivePaySys) ? this.getBankCodeFromPaySys(this.receivePaySys) : null,
                    rate: this.CALC.rate.value.toString(),
                    description: this.description,
                    source: (this.isTgApp) ? 'tgapp' : 'web',
                    recipient_id: recipient_id,
                    recipient_fields: this.recipientFields,
                    browser: {
                        fbp: fbp,
                        fbc: fbc,
                        url: url
                    }
                }

                transfer = await this.connect.WithdrawWalletByTransfer(data).then(res=>res)
                if(transfer.result && transfer.data) {
                    //успешно создали трансфер
                    this.showMess('success', this.lang('success_title'), this.lang('success_subtitle'))

                    // отправляем событие об успешном создании перевода
                    try {
                        const trId = (transfer.data && transfer.data._id) ? transfer.data._id : null
                        const trSenderId = (transfer.data && transfer.data.sender && transfer.data.sender.user_id) ? transfer.data.sender.user_id : null
                        const eventId = (trId) ? 'transfer-' + trId : null
                        const date = (transfer.data && transfer.data.dates && transfer.data.dates.created) ? transfer.data.dates.created : null
                        const timestamp = Math.floor(date / 1000)
                        const userAgent = this.helper.getUserAgent()

                        let fbConv = new FbConversion('transferCreate')
                        if(eventId)     fbConv.setId(eventId)
                        if(trSenderId)  fbConv.setExternalId(trSenderId)
                        if(timestamp)   fbConv.setTime(timestamp)
                        if(userAgent)   fbConv.setUserAgent(userAgent)
                        if(url)         fbConv.setUrl(url)
                        if(fbp)         fbConv.setFbp(fbp)
                        if(fbc)         fbConv.setFbc(fbc)
                        const eventData = fbConv.get()

                        this.event.send('transferCreate', eventData) 
                    } catch (e) {
                        console.log('error send event', e)
                    }

                    this.$router.push({path: '/personal/transfer/'+transfer.data._id})
                } else {
                    if(transfer.error && this.getErrorMessage(transfer.error)) {
                        this.showMess('warn', this.lang('error_title'), this.getErrorMessage(transfer.error)) 
                    } else {
                        if(transfer.message) this.showMess('error', this.lang('error_title'), transfer.message)
                        else this.showMess('error', this.lang('error_title'), 'Unknown error')
                    }
                }
                this.isLoading = false
                this.submitted = false
            } catch(e) {
                console.log('error', e)
                const msg = (e.message) ? e.message : 'Error'
                this.showMess('error', 'Error', msg)
                this.isLoading = false
                this.submitted = false
            }

            return
        },
        async LoadRecipients(){
            const recipients = await RecipientList.GetList(this.$store).then(res => res)
            if (recipients && recipients.length > 0) {
                this.recipients = recipients
            }
        },
        getErrorMessage(code){
            let message = null
            switch(code){
                case 'test_return':
                    message = this.lang('err_test_return')
                    break
                case 'verification_required':
                    message = this.lang('err_verification_required')
                    break
                case 'existing_open_transfers':
                    message = this.lang('err_existing_open_transfers')
                    break
                case 'amounts_not_equal':
                case 'comissions_not_equal':
                    message = this.lang('err_amounts_not_equal')
                    this.refresh()      // обновляем курсы
                    break
                case 'rates_not_equal':
                    message = this.lang('err_rates_not_equal')
                    this.refresh()      // обновляем курсы
                    break
                case "free_transfer_not_available":
                    message = this.lang('err_free_transfer_not_available')
                    this.LoadStatOfUser().then(() => {
                        this.refresh()      // обновляем курсы
                    })
                    break
                default:
                    message = null
            }
            return message
        },
        async getWallets(){
            this.isLoading = true
            try {
                const resWallets = await this.ActionGetAllWallets().then(res=>res)
                if(resWallets.result && resWallets.data && resWallets.data.wallets) this.wallets = resWallets.data.wallets
                else {
                    this.wallets = []
                    this.showMess('error', this.content[this.lang].error, this.content[this.lang].error_text)
                }
            } catch (error) { console.log(error) }
            this.isLoading = false
        },
    },
    beforeCreate() {
        this.connect = new Connect()
        this.event = new Event(this)
        this.helper = new Helper()
    },
    async mounted() {
       
        // платежные системы | обязательно
        this.arrPaymetSystems = await PaymentSystemList.GetList(this.$store).then(r=>r)
        if (!this.arrPaymetSystems || this.arrPaymetSystems.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No payment systems loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrPaymetSystems', this.arrPaymetSystems)

        // валюты | обязательно
        const resCurrencies = await CurrencyList.GetList(this.$store).then(r=>r)
        if (!resCurrencies || resCurrencies.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No currencies loaded' // TODO: вывести ошибку на разных языках
            return
        }
        this.arrCurrencies = CurrencyList.ToObjectMap(resCurrencies)
        this.currencies = resCurrencies
        // console.log('arrCurrencies', this.arrCurrencies)

        // банки | обязательно
        this.arrBanks = await BankList.GetList(this.$store).then(r=>r)
        if (!this.arrBanks || this.arrBanks.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No banks loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrBanks', this.arrBanks)

        // Курсы доступных валют | обязательно
        const resRates = await this.connect.GetRatesByType('withdraw').then(res => res)
        if (!resRates.result || !resRates.data || resRates.data.length <= 0){
            this.totalError = true
            if(resRates.errors && resRates.errors.length > 0) this.totalErrorMessage = resRates.errors[0]
            else this.totalErrorMessage = 'No rates loaded'
            return
        }
        const objRates = new RateList(resRates.data)
        this.rates = objRates.toArrayObj()
        // console.log('rates', this.rates)

        await this.LoadRecipients().then(() => {})

        this.getWallets()

        this.loaded = true
        this.react.recalculating_ = true
        this.recalculating = true

        this.Recalculate('start').then(res => {
            this.react.recalculating_ = false
            this.recalculating = false
        })
	}
}
</script>